import { kebabCase } from 'lodash';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { ConversationSelectType } from './enums';

export const useConversationSelectTypeValues = () => {
  const intl = useIntl();

  const data = useMemo(
    () =>
      Object.values(ConversationSelectType).map(option => ({
        key: option,
        title: intl.formatMessage({
          id: `common.conversation.conversation-type.${kebabCase(option)}`,
        }),
      })),
    [intl]
  );

  return {
    data,
    loading: false,
  };
};
